import { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router";
import { TaxLoader } from "./components/TaxLoader";
import routes from "./routes";
import { ThemeProvider } from "./context/ThemeContext";
import { NotificationProvider } from "./context/NotificationContext";


export default function App() {
  return (
    <ThemeProvider>
      <NotificationProvider>
        <Suspense fallback={<TaxLoader message="Loading..." />}>
          <Routes>
            {routes.map((route) => (
              <Route key={route.path} path={route.path} element={route.element}>
                {route.children?.map((child) => (
                  <Route
                    key={child.path}
                    path={child.path}
                    element={child.element}
                  />
                ))}
              </Route>
            ))}
            <Route path="/" element={<Navigate to="/welcome" replace />} />
            <Route path="*" element={<Navigate to="/not-found" replace />} />
          </Routes>
        </Suspense>
      </NotificationProvider>
    </ThemeProvider>
  );
}